import React from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

export function DropdownMenuSeparator() {
  return (
    <DropdownMenuPrimitive.Separator className="atlas-h-px atlas-bg-border-divider-subtle atlas-w-auto atlas-my-2" />
  );
}
